export const sizes = {
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '2.5rem',
  },
  
  padding: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    button: '0.5rem 1rem',
    hamburgerItem: '1rem 1.5rem',
    drawer: '1rem',
    drawerTop: '1rem 0',
    segmented: '4px 12px',
    languageBtn: '0.5rem 1rem',
  },
  
  margin: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    auto: '0 auto',
    hamburgerItem: '0.5rem 0',
  },
  
  borderRadius: {
    small: '4px',
    medium: '20px',
    large: '25px',
  },
  
  dimensions: {
    logoDesktop: '60px',
    logoMobile: '40px',
    hamburgerItem: '50px',
    languageSelector: '45px',
    segmentedMinHeight: '32px',
    navigationMinHeight: '200px',
    shadowHeight: '10px',
    borderWidth: '3px',
    borderStandard: '1px',
    borderThick: '4px',
  },
  
  layout: {
    maxWidth: '1200px',
    drawerWidth: 'default',
  },
  
  gap: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '4rem',
    xxxl: '8rem',
  },
  
  pixels: {
    tiny: '4px',
    small: '8px',
    medium: '10px',
    languageSelectorOffset: '18px',
  },
} as const;

export type Sizes = typeof sizes;